import { useMemo } from 'react';

import { ReportTemplate } from 'api/endPoints/GetReportTemplateList';

import { isTemplateBuiltByForesight } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.utils';
import { UseInitialTemplateCardProvider } from 'components/widgets/ReportsHome/ReportsTemplates/components/InitialTemplateCards/InitialTemplateCard.provider';

const USERS_TEMPLATES_ARRAY_INDEX = 0;
const FORESIGHT_TEMPLATES_ARRAY_INDEX = 1;

type TemplatesTuple<T> = [T[], T[]];

interface Props {
    api: UseInitialTemplateCardProvider['api'];
}

export const useInitialTemplateCardsLogic = ({ api }: Props) => {
    const templateList = api.getReportTemplates.data;

    const [usersTemplateList, foresightTemplateList]: TemplatesTuple<ReportTemplate> = useMemo(() => {
        if (templateList === undefined || templateList === null) {
            return [[], []];
        }
        const [usersTemplates, foresightTemplates] = templateList.reduce(
            (acc, template) => {
                if (isTemplateBuiltByForesight(template.createdBy.email)) {
                    acc[FORESIGHT_TEMPLATES_ARRAY_INDEX].push(template);
                } else {
                    acc[USERS_TEMPLATES_ARRAY_INDEX].push(template);
                }
                return acc;
            },
            [[], []] as TemplatesTuple<ReportTemplate>,
        );
        return [usersTemplates, foresightTemplates];
    }, [templateList]);

    return {
        logic: {
            usersTemplateList,
            foresightTemplateList,
        },
    };
};
